import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { FaUndo } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import { IoExitOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { API_HOST } from "../../api_utils";
import axios from "axios";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { Autocomplete, TextField } from "@mui/material";
// import managerCashUpdate from './managerCashUpdate'

function CashPlus(props) {
  const { userDataFromStorage, coloredTheme } = props;
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [managerList, setManagerList] = useState([]);
  const [cashReconciliationList, setCashReconciliationList] = useState([]);
  const [
    managerAgentCashReconciliationList,
    setManagerAgentCashReconciliationList,
  ] = useState([]);
  const [showAddReconciliation, setShowAddReconciliation] = useState(false);
  const [selectedAgentRef, setSelectedAgentRef] = useState({});

  const [addReconciliationPayload, setAddReconciliationPayload] = useState({
    employee_ref: "",
    cash_difference: "",
    start_date: "",
    end_date: new Date().toISOString().split("T")[0],
  });

  // states for filter:
  const [managerLastName, setManagerLastName] = useState("");
  const [agentLastName, setAgentLastName] = useState("");
  const [filterData, setFilterData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [managerNameList, setManagerNameList] = useState([]);
  const [agentNameList, setAgentNameList] = useState([]);
  const [showEditReconciliation, setShowEditReconciliation] = useState(false);
  const [periodStartDate, setPeriodStartDate] = useState("");
  const [periodEndDate, setPeriodEndDate] = useState("");

  let getStoredReconciliation = JSON.parse(
    sessionStorage.getItem("reconciliation")
  );

  const [editReconciliationData, setEditReconciliationData] = useState([]);
  const [showDataToAppend, setShowDataToAppend] = useState([]);
  const [showManagerCashUpdate, setShowManagerCashUpdate] = useState(false);
  const [managerEditReconciliation, setManagerEditReconciliation] =
    useState("");

  const [showChangedCash, setShowChangedCash] = useState(false);

  const [agentNameForApi, setAgentNameForApi] = useState("");
  const [selectedAgentName, setSelectedAgentName] = useState("");
  const [managerNameForApi, setManagerNameForApi] = useState("");
  const [selectedManagerName, setSelectedManagerName] = useState("");
  const [agentCashIn, setAgentCashIn] = useState({});
  const [agentClaims, setAgentClaims] = useState({});
  const [agentCashOut, setAgentCashOut] = useState({});
  const [lastRecord, setLastRecord] = useState({});
  const [reportDate, setReportDate] = useState("");
  const [reconciliationSuccess, setReconciliationSuccess] = useState(false);
  const [reconciliationDoneToday, setReconciliationDoneToday] = useState(false);
  const searchFilterOptionsShowAgent = useRef(true);
  const searchFilterOptionsShowManager = useRef(true);

  const getAllManagerNames = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/manager_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setManagerNameList(data);
    } else {
      setLoading(false);
    }
  };

  const getAllAgentNames = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/agent_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setAgentNameList(data);
    } else {
      setLoading(false);
    }
  };

  const getCashReconciliationList = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/get_cash_plus?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];
    if (managerNameForApi) {
      queryParams.push(`manager_name=${managerNameForApi}`);
    }

    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (data.message) {
        setLoading(false);
      } else {
        setLoading(false);
        setManagerAgentCashReconciliationList(data);
        setFilterData(data);
      }
    } else {
      setLoading(false);
    }
  };

  const getCnnyStartDateHandler = async () => {
    const { data } = await axios.get(
      `${API_HOST}/api/users/get_cnny_start_date`
    );
    if (data) {
      if (!data.message) {
        console.log("data::::", data);
        setReportDate(new Date(data[0].cn_ny_start));
      }
    }
  };

  useEffect(() => {
    getCashReconciliationList();
    getAllManagerNames();
    getAllAgentNames();
    getCnnyStartDateHandler();

    return () => {
      setReconciliationSuccess(false);
    };
  }, [currentPage, reconciliationSuccess]);

  useEffect(() => {
    if (reportDate) {
      setAddReconciliationPayload((prevState) => ({
        ...prevState,
        start_date: new Date(reportDate).toISOString().split("T")[0],
      }));
    }
  }, [reportDate]);

  // function to handle increments in date based on payment frequency of the loan product:
  function moveDate(date, number, unit) {
    const d = new Date(date);
    switch (unit) {
      case "days":
        d.setDate(d.getDate() + number);
        break;
      case "weeks":
        d.setDate(d.getDate() + number * 7);
        break;
      case "months":
        d.setMonth(d.getMonth() + number);
        break;
      case "years":
        d.setFullYear(d.getFullYear() + number);
        break;
      default:
        break;
    }
    return d;
  }

  // function to handle date differences based on payment frequency of the loan product:
  function dateDiff(date1, date2, unit) {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    const diff = d1.getTime() - d2.getTime();

    switch (unit) {
      case "years":
        return Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
      case "months":
        return Math.floor(diff / (1000 * 60 * 60 * 24 * 30));
      case "weeks":
        return Math.floor(diff / (1000 * 60 * 60 * 24 * 7));
      case "days":
        return Math.floor(diff / (1000 * 60 * 60 * 24));
      default:
        return undefined;
    }
  }

  // sum
  function sumFirstIndex(arr, nameToBeRendered) {
    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
      sum += arr[i][`${nameToBeRendered}`];
    }
    return sum;
  }

  function setToMidnight(date) {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
  }

  const newReconciliationHandler = (data) => {
    if (
      setToMidnight(data.last_reconciliation).getTime() ===
      setToMidnight(new Date()).getTime()
    ) {
      toast.warn("You Have Already Made A Reconciliation Today !!!");
    } else {
      setShowAddReconciliation(true);
      setSelectedAgentRef(data);
    }
  };

  const addReconciliationHandler = async () => {
    setLoading(true);
    if (
      addReconciliationPayload.start_date &&
      addReconciliationPayload.end_date &&
      addReconciliationPayload.cash_difference
    ) {
      let endDate = new Date(addReconciliationPayload.end_date);

      if (!isNaN(parseInt(addReconciliationPayload.cash_difference))) {
        if (endDate <= new Date()) {
          const config = {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userDataFromStorage.token}`,
            },
          };
          const { data } = await axios.post(
            `${API_HOST}/api/reconciliation/add_reconciliation`,
            addReconciliationPayload,
            config
          );
          if (data) {
            if (data.message) {
              toast.error(data.message);
              setLoading(false);
            } else {
              setLoading(false);
              toast.success("Cash Reconciliation Added Successfully !!!");
              setReconciliationSuccess(true);
              // showEditReconciliation(false);
              // setShowAddReconciliation(false);
              window.location.reload();
            }
          }
        } else {
          toast.error("End Date Must Be Less Than or Equal to Current date!!!");
        }
      } else {
        toast.warn("Please provide a valid cash +/- value !!!");
      }
    } else {
      setLoading(false);
      toast.error("Make Sure To Fill All Fields !!!");
    }
  };

  useEffect(() => {
    getCashReconciliationList();
  }, [agentNameForApi, managerNameForApi]);

  const showEditHandler = (x, event) => {
    if (userDataFromStorage.user_role === "admin") {
      event.preventDefault();
      setShowEditReconciliation(true);
      setEditReconciliationData(x);
    }
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    let todayDate = new Date();
    let prevDate = new Date(todayDate); // Make a copy of todayDate
    prevDate.setMonth(prevDate.getMonth() - 1); // Subtract 1 month from the copy

    // Format the dates as strings before setting them in the state
    setPeriodStartDate(formatDate(prevDate));
    setPeriodEndDate(formatDate(todayDate));
  }, []);

  useEffect(() => {
    if (showEditReconciliation && editReconciliationData) {
      if (editReconciliationData.end_date) {
      }
    }
  }, [
    periodStartDate,
    periodEndDate,
    showEditReconciliation,
    editReconciliationData,
  ]);

  const adjustCashByAdmin = async () => {
    console.log("show edit :::::", editReconciliationData);

    if (managerEditReconciliation) {
      let finalAdjustment =
        parseInt(managerEditReconciliation) +
        parseInt(editReconciliationData.cash_difference);
      let payload = {
        cash_adjustment: finalAdjustment,
      };

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      const { data } = await axios.put(
        `${API_HOST}/api/reconciliation/${editReconciliationData.id_number}`,
        payload,
        config
      );
      if (data) {
        if (data.message === "Cash adjustment added successfully!!!") {
          toast.success(data.message);
          window.location.reload();
        } else {
          toast.warn("something went wrong!!!!");
        }
      }
    } else {
      toast.warn("Please provide a Cash Adjustment value!!!!");
    }
  };

  const handleAgentNameChange = useCallback((e) => {
    setAgentLastName(e.target.value);
  }, []);

  const handleManagerNameChange = useCallback((e) => {
    setManagerLastName(e.target.value);
  }, []);

  const filteredAgentOptions = useMemo(() => {
    if (agentLastName && !selectedAgentName) {
      console.log("here");
      const searchTerm = agentLastName.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      agentNameList.forEach((option) => {
        if (
          option.agent_name &&
          option.agent_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.agent_name.toLowerCase().startsWith(searchTerm)",
            option.agent_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.agent_name.localeCompare(b.agent_name, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedAgentName) {
        console.log("here agent1111");
        setAgentNameForApi(selectedAgentName);
        setSelectedAgentName("");

        searchFilterOptionsShowAgent.current = false;
      } else {
        console.log("here agent222");
        searchFilterOptionsShowAgent.current = true;
      }

      return [];
    }
  }, [agentLastName, selectedAgentName]);

  const filteredManagerOptions = useMemo(() => {
    if (managerLastName && !selectedManagerName) {
      console.log("here");
      const searchTerm = managerLastName.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      managerNameList.forEach((option) => {
        if (
          option.manager_name &&
          option.manager_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.manager_name.toLowerCase().startsWith(searchTerm)",
            option.manager_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.manager_name.localeCompare(b.manager_name, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedManagerName) {
        setManagerNameForApi(selectedManagerName);
        setSelectedManagerName("");

        searchFilterOptionsShowManager.current = false;
      } else {
        searchFilterOptionsShowManager.current = true;
      }

      return [];
    }
  }, [managerLastName, selectedManagerName]);

  const getCashInCashPlusHandler = async (user) => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl;
    if (
      userDataFromStorage.user_role === "admin" ||
      userDataFromStorage.user_role === "manager"
    ) {
      apiUrl = `${API_HOST}/api/users/cash_plus_cash_in?user=${user}`;
    } else {
      apiUrl = `${API_HOST}/api/users/cash_plus_cash_in2?user=${user}`;
    }

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (data.message) {
        setLoading(false);
      } else {
        setLoading(false);
        setAgentCashIn(data[0]);
      }
    } else {
      setLoading(false);
    }
  };

  const getCashOutCashPlusHandler = async (user) => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl;
    if (
      userDataFromStorage.user_role === "admin" ||
      userDataFromStorage.user_role === "manager"
    ) {
      apiUrl = `${API_HOST}/api/users/cash_plus_cash_out?user=${user}`;
    } else {
      apiUrl = `${API_HOST}/api/users/cash_plus_cash_out2?user=${user}`;
    }

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (data.message) {
        setLoading(false);
      } else {
        setLoading(false);
        setAgentCashOut(data[0]);
      }
    } else {
      setLoading(false);
    }
  };

  const getClaimsCashPlusHandler = async (user) => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl;
    if (
      userDataFromStorage.user_role === "admin" ||
      userDataFromStorage.user_role === "manager"
    ) {
      apiUrl = `${API_HOST}/api/users/cash_plus_claims?user=${user}`;
    } else {
      apiUrl = `${API_HOST}/api/users/cash_plus_claims2?user=${user}`;
    }

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (data.message) {
        setLoading(false);
      } else {
        setLoading(false);
        setAgentClaims(data[0]);
      }
    } else {
      setLoading(false);
    }
  };

  const getlastWeekMonthCashPlusHandler = async (user) => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/cash_plus_last_month?user=${user}`;

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (data.message) {
        setLoading(false);
      } else {
        setLoading(false);
        setLastRecord(data);
      }
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      userDataFromStorage.user_role === "admin" ||
      userDataFromStorage.user_role === "manager"
    ) {
      if (selectedAgentRef && showAddReconciliation) {
        console.log("selectedAgentRef", selectedAgentRef);
        getCashInCashPlusHandler(selectedAgentRef.agent_id);
        getCashOutCashPlusHandler(selectedAgentRef.agent_id);
        getClaimsCashPlusHandler(selectedAgentRef.agent_id);
        getlastWeekMonthCashPlusHandler(selectedAgentRef.agent_id);
      }
    }
  }, [selectedAgentRef, showAddReconciliation]);

  useEffect(() => {
    if (
      userDataFromStorage.user_role === "agent" ||
      userDataFromStorage.user_role === "senior_agent"
    ) {
      if (filterData.length) {
        if (
          setToMidnight(filterData[0].last_reconciliation).getTime() ===
          setToMidnight(new Date()).getTime()
        ) {
          setReconciliationDoneToday(true);
        }
        getCashInCashPlusHandler(filterData[0].agent_id);
        getCashOutCashPlusHandler(filterData[0].agent_id);
        getClaimsCashPlusHandler(filterData[0].agent_id);
        getlastWeekMonthCashPlusHandler(filterData[0].agent_id);
      }
    }
  }, [filterData]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      {!showManagerCashUpdate && (
        <p className="text-gray-800 text-[1.8rem] tracking-wider">Cash +/-</p>
      )}

      <div
        className={
          userDataFromStorage.user_role === "agent" ||
          userDataFromStorage.user_role === "senior_agent"
            ? "hidden"
            : "block"
        }>
        {showAddReconciliation ? (
          <>
            <div className="mt-6 flex justify-start items-center space-x-3 md:space-x-0">
              <p className="md:w-[20rem] text-gray-600">Agent Name :</p>
              <p>{selectedAgentRef.agent}</p>
            </div>
            <div className="mt-2 flex justify-start items-center space-x-3 md:space-x-0">
              <p className="md:w-[20rem] text-gray-600">
                Total of Cash $+/- In Last Week Is :
              </p>
              <p>MYR {lastRecord ? lastRecord.lastWeekCash : ""}</p>
            </div>
            <div className="mt-2 flex justify-start items-center space-x-3 md:space-x-0">
              <p className="md:w-[20rem] text-gray-600">
                Total of Cash $+/- In Last Month Is :
              </p>
              <p>MYR {lastRecord ? lastRecord.lastMonthCash : ""}</p>
            </div>
            <div className="mt-2 flex justify-start items-center space-x-3 md:space-x-0">
              <label htmlFor="startDate" className="md:w-[20rem] text-gray-600">
                Start Date
              </label>
              <input
                value={addReconciliationPayload?.start_date}
                disabled={true}
                type="date"
                id="startDate"
                placeholder="Enter a Start Date "
                className="outline-none border-sky-300 border rounded-lg p-[0.5rem] flex-1"
              />
            </div>
            <div className="mt-2 flex justify-start items-center space-x-3 md:space-x-0">
              <label htmlFor="endDate" className="md:w-[20rem] text-gray-600">
                End Date
              </label>
              <input
                onChange={(e) =>
                  setAddReconciliationPayload((prevState) => ({
                    ...prevState,
                    end_date: e.target.value,
                  }))
                }
                value={addReconciliationPayload?.end_date}
                id="endDate"
                type="date"
                placeholder="Enter a End Date"
                className="outline-none border-sky-300 border rounded-lg p-[0.5rem] flex-1"
              />
            </div>
            <div className="mt-2 flex justify-start items-center text-[0.8rem] text-gray-700 space-x-3">
              <div className="flex justify-start items-center space-x-1">
                <p>Cash In :</p>
                <p>MYR {agentCashIn ? agentCashIn.cash_in : ""}</p>
              </div>
              <div className="flex justify-start items-center space-x-1">
                <p>Cash Out :</p>
                <p>MYR {agentCashOut ? agentCashOut.cash_out : ""}</p>
              </div>
              <div className="flex justify-start items-center space-x-1">
                <p>Claims :</p>
                <p>MYR {agentClaims ? agentClaims.claims : ""}</p>
              </div>
            </div>
            <div className="mt-2 flex justify-start items-center">
              <label className="w-[20rem] text-gray-600">Cash +/-</label>
              <input
                onChange={(e) =>
                  setAddReconciliationPayload((prevState) => ({
                    ...prevState,
                    cash_difference: e.target.value,
                    employee_ref: selectedAgentRef.agent_id,
                  }))
                }
                value={addReconciliationPayload?.cash_difference}
                type="text"
                placeholder="Enter Cash Out Detail"
                className="outline-none border-sky-300 border rounded-lg p-[0.5rem] flex-1"
              />
            </div>

            <div className="mt-2 flex justify-start items-center space-x-3">
              <button
                onClick={() => addReconciliationHandler()}
                style={{ backgroundColor: coloredTheme }}
                className="flex justify-center items-center mt-6 rounded space-x-2 transition duration-[0.6s] px-[1rem] py-[0.5rem] text-white">
                <FiSearch />
                <p>Save</p>
              </button>
              <button
                style={{ backgroundColor: coloredTheme }}
                onClick={() => setShowAddReconciliation(false)}
                className="flex justify-center items-center mt-6 rounded space-x-2 transition duration-[0.6s] px-[1rem] py-[0.5rem] text-white">
                <FiSearch />
                <p>Cancel</p>
              </button>
            </div>
          </>
        ) : !showEditReconciliation && !showManagerCashUpdate ? (
          <>
            <div className="bg-white mt-6">
              <p
                style={{ backgroundColor: coloredTheme }}
                className=" text-white px-[0.5rem] py-[1rem] ">
                Agent Selection
              </p>
              <div className="mt-2 bg-white  px-[0.5rem] pb-[1rem]">
                {userDataFromStorage.user_role === "admin" && (
                  <div className="relative md:flex justify-start items-center mt-6">
                    <p className="w-[30%]">Manager Last Name</p>
                    <input
                      type="text"
                      value={managerLastName}
                      placeholder="Enter Manager Last Name"
                      onInput={(e) => {
                        console.log("e.target::::::", e.target.value);
                        handleManagerNameChange(e);
                      }}
                      className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
                    />
                    {filteredManagerOptions.length > 0 && (
                      <div
                        className={
                          searchFilterOptionsShowManager?.current
                            ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                            : "hidden"
                        }>
                        {filteredManagerOptions.map((option, index) => (
                          <div
                            className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                            onClick={() => {
                              setSelectedManagerName(option.manager_name);
                              setManagerLastName(option.manager_name);
                            }}
                            key={index}>
                            {option.manager_name}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
                <div className="relative md:flex justify-start items-center mt-6">
                  <p className="w-[30%]">Agent Last Name</p>
                  <input
                    type="text"
                    value={agentLastName}
                    placeholder="Enter Agent Last Name"
                    onInput={(e) => {
                      console.log("e.target::::::", e.target.value);
                      handleAgentNameChange(e);
                    }}
                    className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
                  />
                  {filteredAgentOptions.length > 0 && (
                    <div
                      className={
                        searchFilterOptionsShowAgent.current === true
                          ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                          : "hidden"
                      }>
                      {filteredAgentOptions.map((option, index) => (
                        <div
                          className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                          onClick={() => {
                            console.log(
                              "option.agent_name::",
                              option.agent_name
                            );
                            setAgentLastName(option.agent_name);
                            setSelectedAgentName(option.agent_name);
                          }}
                          key={index}>
                          {option.agent_name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className="flex justify-start items-center space-x-4">
                  <button
                    onClick={() => getCashReconciliationList()}
                    style={{ backgroundColor: coloredTheme }}
                    className="flex justify-center items-center rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white ">
                    <FiSearch />
                    <p>Search</p>
                  </button>
                  <button
                    onClick={() => {
                      setManagerLastName("");
                      setAgentLastName("");
                      setAgentNameForApi("");
                      setManagerNameForApi("");
                      // setFilterData(managerAgentCashReconciliationList)
                    }}
                    style={{ backgroundColor: coloredTheme }}
                    className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
                    <FaUndo />
                    <p>Reset</p>
                  </button>
                </div>
              </div>
            </div>

            <div className="mt-8 overflow-scroll">
              <p
                style={{ backgroundColor: coloredTheme }}
                className=" lg:w-[100%] md:w-[130%] w-[250%] text-white px-[0.5rem] py-[1rem] ">
                Agent Details - Click on a row to see Cash Adjustment for that
                agent
              </p>
              {/* check for table */}
              {/* user status must be active */}

              <table className="lg:w-[100%] md:w-[130%] w-[250%]">
                <thead className="h-[5vh] ">
                  <tr>
                    {userDataFromStorage.user_role === "admin" && (
                      <th className="text-start">Manager</th>
                    )}
                    <th className="text-start">Agent</th>
                    <th className="text-start">User role</th>
                    <th className="text-start">Last Reconciliation</th>
                  </tr>
                </thead>
                <tbody>
                  {filterData.length
                    ? filterData.map((x) => {
                        const inputDate = new Date(x?.last_reconciliation);

                        const months = [
                          "January",
                          "February",
                          "March",
                          "April",
                          "May",
                          "June",
                          "July",
                          "August",
                          "September",
                          "October",
                          "November",
                          "December",
                        ];

                        console.log("input date", inputDate);

                        const day = inputDate.getDate();
                        console.log("day::::", day);
                        const month = months[inputDate.getMonth()];
                        const year = inputDate.getFullYear();

                        const modifiedLastTransactionDate = `${day} ${month}, ${year}`;

                        if (
                          userDataFromStorage.user_role === "agent" ||
                          userDataFromStorage.user_role === "senior_agent"
                        ) {
                        }

                        return (
                          <tr
                            onClick={(event) => showEditHandler(x, event)}
                            className="border-b bg-white">
                            {userDataFromStorage.user_role === "admin" && (
                              <td>{x.manager}</td>
                            )}
                            <td>{x.agent}</td>
                            <td>{x.user_role}</td>
                            <td>{modifiedLastTransactionDate}</td>

                            {userDataFromStorage.user_role === "admin" ||
                            userDataFromStorage.user_role === "manager" ? (
                              <td className="py-2">
                                <button
                                  onClick={() => newReconciliationHandler(x)}
                                  style={{ backgroundColor: coloredTheme }}
                                  className={
                                    new Date(
                                      x.last_reconciliation
                                    ).toDateString() ===
                                    new Date().toDateString()
                                      ? "hidden"
                                      : "flex justify-center items-center rounded space-x-2 px-[1rem] py-[0.5rem] text-white"
                                  }>
                                  <p>$ New Reconciliation</p>
                                </button>
                              </td>
                            ) : (
                              ""
                            )}
                          </tr>
                        );
                      })
                    : ""}
                </tbody>
              </table>

              <div className="flex justify-end space-x-4 items-center mt-4  h-[50%]">
                <button
                  className=" px-6 py-2 rounded-lg text-white bg-gray-400 hover:bg-gray-200 shadow-xl hover:text-gray-600 transition duration-[0.5s] tracking-wider"
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}>
                  Prev
                </button>
                <button
                  className=" px-6 py-2 rounded-lg text-white bg-gray-400 hover:bg-gray-200 shadow-xl hover:text-gray-600 transition duration-[0.5s] tracking-wider"
                  onClick={() => setCurrentPage(currentPage + 1)}>
                  Next
                </button>
              </div>
              <div
                onClick={() => navigate("/home")}
                className="mt-6 flex justify-end lg:w-[100%] md:w-[130%] w-[250%]">
                <button
                  style={{ backgroundColor: coloredTheme }}
                  className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem]  text-white">
                  <IoExitOutline />
                  <p>Exit</p>
                </button>
              </div>
            </div>
          </>
        ) : showEditReconciliation && !showManagerCashUpdate ? (
          <>
            <div className="bg-white mt-6">
              <p className="p-[0.5rem] font-Roboto font-[500] tracking-wider">
                Agent : {editReconciliationData?.agent}
              </p>
              <p
                style={{ backgroundColor: coloredTheme }}
                className=" text-white px-[0.5rem] py-[1rem] ">
                Search Parameters
              </p>
              <div className="mt-2 bg-white  px-[0.5rem] pb-[1rem]">
                <div className="md:flex justify-start items-center">
                  <p className="w-[25rem]">Period Start Date</p>

                  <input
                    onChange={(event, newValue) => {
                      setPeriodStartDate(event.target.value);
                    }}
                    value={periodStartDate}
                    type="date"
                    className="outline-none p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0 border border-gray-400 text-gray-700 font-Roboto py-[0.5rem] px-[0.2rem] rounded-lg "
                    placeholder="Enter Period Start Date ...."
                  />
                </div>
                <div className="md:flex justify-start items-center mt-6">
                  <p className="w-[25rem]">Period End Date</p>

                  <input
                    onChange={(event, newValue) => {
                      setPeriodEndDate(event.target.value);
                    }}
                    value={periodEndDate}
                    type="date"
                    className="outline-none p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0 border border-gray-400 text-gray-700 font-Roboto py-[0.5rem] px-[0.2rem] rounded-lg "
                    placeholder="Enter Period End Date ...."
                  />
                </div>
                <div className="flex justify-start items-center space-x-4">
                  <button
                    onClick={() => getCashReconciliationList()}
                    style={{ backgroundColor: coloredTheme }}
                    className="flex justify-center items-center rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white ">
                    <FiSearch />
                    <p>Search</p>
                  </button>
                  <button
                    onClick={() => {
                      setManagerLastName("");
                      setAgentLastName("");
                      // setFilterData(managerAgentCashReconciliationList)
                    }}
                    style={{ backgroundColor: coloredTheme }}
                    className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
                    <FaUndo />
                    <p>Reset</p>
                  </button>
                </div>
                <p className="p-[0.5rem] font-Roboto font-[400] tracking-wider">
                  Total of Adjustments in the report period is: MYR{" "}
                  {editReconciliationData?.cash_difference}
                </p>
              </div>
            </div>

            <div className="mt-8 overflow-scroll">
              <p
                style={{ backgroundColor: coloredTheme }}
                className=" lg:w-[100%] md:w-[130%] w-[250%] text-white px-[0.5rem] py-[1rem] ">
                Cash Adjustment Report
              </p>
              {/* check for table */}
              {/* user status must be active */}

              <table className="lg:w-[100%] md:w-[130%] w-[250%]">
                <thead className="h-[5vh] ">
                  <tr>
                    <th className="text-start">Start Date</th>

                    <th className="text-start">End Date</th>
                    <th className="text-start">Cash Adjustment $+/-</th>
                    <th className="text-start">Entered By</th>
                  </tr>
                </thead>
                <tbody>
                  {filterData.length > 0 &&
                    filterData.map((x, index) => {
                      if (x.id_number === editReconciliationData.id_number) {
                        console.log("x here111::::::::", x);
                        console.log(
                          "edit here111::::::::::",
                          editReconciliationData
                        );
                        if (
                          setToMidnight(x?.end_date).getTime() >
                            setToMidnight(periodStartDate).getTime() &&
                          setToMidnight(x?.end_date).getTime() <
                            setToMidnight(periodEndDate).getTime() +
                              24 * 60 * 60 * 1000
                        ) {
                          console.log("x here::::::::", x);
                          console.log(
                            "edit here::::::::::",
                            editReconciliationData
                          );

                          const inputDate = new Date(x?.start_date);

                          const months = [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December",
                          ];

                          console.log("input date", inputDate);

                          const day = inputDate.getDate();
                          console.log("day::::", day);
                          const month = months[inputDate.getMonth()];
                          const year = inputDate.getFullYear();

                          const startDateNew = `${day} ${month}, ${year}`;

                          const inputDate1 = new Date(x?.end_date);

                          const months1 = [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December",
                          ];

                          console.log("input date", inputDate1);

                          const day1 = inputDate1.getDate();
                          console.log("day::::", day);
                          const month1 = months1[inputDate1.getMonth()];
                          const year1 = inputDate1.getFullYear();

                          const endDateNew = `${day1} ${month1}, ${year1}`;
                          return (
                            <tr
                              key={index}
                              // onClick={() => showEditHandler(x)}
                              className="border-b bg-white">
                              <td>{startDateNew}</td>
                              <td>{endDateNew}</td>
                              <td>{x.cash_difference}</td>
                              <td>{x.agent}</td>
                              <td>
                                <button
                                  onClick={() => setShowManagerCashUpdate(true)}
                                  style={{ backgroundColor: coloredTheme }}
                                  className="px-6 py-2 rounded-lg text-white tracking-wider">
                                  Update Admin
                                </button>
                              </td>
                            </tr>
                          );
                        }
                      }
                    })}
                </tbody>
              </table>

              <div className="flex justify-end space-x-4 items-center mt-4  h-[50%]">
                <button
                  className=" px-6 py-2 rounded-lg text-white bg-gray-400 hover:bg-gray-200 shadow-xl hover:text-gray-600 transition duration-[0.5s] tracking-wider"
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}>
                  Prev
                </button>
                <button
                  className=" px-6 py-2 rounded-lg text-white bg-gray-400 hover:bg-gray-200 shadow-xl hover:text-gray-600 transition duration-[0.5s] tracking-wider"
                  onClick={() => setCurrentPage(currentPage + 1)}>
                  Next
                </button>
              </div>
              <div
                onClick={() => navigate("/home")}
                className="mt-6 flex justify-end lg:w-[100%] md:w-[130%] w-[250%]">
                <button
                  style={{ backgroundColor: coloredTheme }}
                  className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem]  text-white">
                  <IoExitOutline />
                  <p>Exit</p>
                </button>
              </div>
            </div>
          </>
        ) : showEditReconciliation && showManagerCashUpdate ? (
          <div>
            <p className="text-gray-800 text-[1.8rem] tracking-wider">
              Manager Cash +/- Update
            </p>
            <div className="mt-6 flex justify-start items-center space-x-2 md:space-x-0">
              <p className="md:w-[20rem] text-gray-600">Agent Name :</p>
              <p>{editReconciliationData.agent}</p>
            </div>
            <div className="mt-2 flex justify-start items-center space-x-2 md:space-x-0">
              <p className="md:w-[20rem] text-gray-600">Start Date :</p>
              <p>
                {editReconciliationData.start_date
                  ? new Date(editReconciliationData.start_date).toDateString()
                  : ""}
              </p>
            </div>
            <div className="mt-2 flex justify-start items-center space-x-2 md:space-x-0">
              <p className="md:w-[20rem] text-gray-600">End Date :</p>
              <p>
                {editReconciliationData.end_date
                  ? new Date(editReconciliationData.end_date).toDateString()
                  : ""}
              </p>
            </div>
            <div className="mt-2 flex justify-start items-center space-x-2 md:space-x-0">
              <p className="md:w-[20rem] text-gray-600">
                Agent Entered Cash +/- :
              </p>
              <p>MYR {editReconciliationData.cash_difference}</p>
            </div>
            <div className="mt-2 md:flex justify-start items-center">
              <label htmlFor="endDate" className="md:w-[20rem] text-gray-600">
                Change in Cash +/-
              </label>
              <input
                onChange={(e) => {
                  setShowChangedCash(true);
                  setManagerEditReconciliation(e.target.value);
                }}
                value={managerEditReconciliation}
                id="endDate"
                type="number"
                placeholder="Enter a Change Amount"
                className="outline-none border-sky-300 border rounded-lg p-[0.5rem] w-[100%] md:w-auto md:flex-1"
              />
            </div>

            {showChangedCash ? (
              <div className="mt-2 flex justify-start items-center space-x-2 md:space-x-0">
                <p className="md:w-[20rem] text-gray-600">
                  New Cash +/- Total:
                </p>
                <p>
                  MYR{" "}
                  {parseInt(managerEditReconciliation) +
                    parseInt(editReconciliationData.cash_difference)}
                </p>
              </div>
            ) : (
              ""
            )}

            <div className="mt-2 flex justify-start items-center space-x-3">
              <button
                onClick={() => adjustCashByAdmin()}
                style={{ backgroundColor: coloredTheme }}
                className="flex justify-center items-center mt-6 rounded space-x-2 transition duration-[0.6s] px-[1rem] py-[0.5rem] text-white">
                <FiSearch />
                <p>Save</p>
              </button>
              <button
                style={{ backgroundColor: coloredTheme }}
                onClick={() => {
                  setShowManagerCashUpdate(false);
                  setShowEditReconciliation(false);
                }}
                className="flex justify-center items-center mt-6 rounded space-x-2 transition duration-[0.6s] px-[1rem] py-[0.5rem] text-white">
                <FiSearch />
                <p>Cancel</p>
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      {userDataFromStorage.user_role === "agent" ||
      userDataFromStorage.user_role === "senior_agent" ? (
        <>
          {reconciliationDoneToday ? (
            <p className=" font-Roboto tracking-wider text-[1.3rem] text-blue-500 font-[500]">
              You Have Already Done Reconciliation For Today !!!
            </p>
          ) : (
            ""
          )}
          <div className="mt-6 flex justify-start items-center">
            <p className="w-[20rem] text-gray-600">Agent Name :</p>
            <p>{filterData[0]?.agent}</p>
          </div>
          <div className="mt-2 flex justify-start items-center">
            <p className="w-[20rem] text-gray-600">
              Total of Cash $+/- In Last Week Is :
            </p>
            <p> MYR {lastRecord?.lastWeekCash}</p>
          </div>
          <div className="mt-2 flex justify-start items-center">
            <p className="w-[20rem] text-gray-600">
              Total of Cash $+/- In Last Month Is :
            </p>
            <p> MYR {lastRecord?.lastMonthCash}</p>
          </div>
          <div
            className={
              reconciliationDoneToday
                ? "hidden"
                : "mt-2 flex justify-start items-center"
            }>
            <label htmlFor="startDate" className="w-[20rem] text-gray-600">
              Start Date
            </label>
            <input
              onChange={(e) =>
                setAddReconciliationPayload((prevState) => ({
                  ...prevState,
                  start_date: e.target.value,
                }))
              }
              value={addReconciliationPayload?.start_date}
              type="date"
              id="startDate"
              placeholder="Enter a Start Date"
              className={
                reconciliationDoneToday
                  ? "hidden"
                  : "outline-none border-sky-300 border rounded-lg p-[0.5rem] flex-1"
              }
              disabled
            />
          </div>
          <div
            className={
              reconciliationDoneToday
                ? "hidden"
                : "mt-2 flex justify-start items-center"
            }>
            <label htmlFor="endDate" className="w-[20rem] text-gray-600">
              End Date
            </label>
            <input
              onChange={(e) =>
                setAddReconciliationPayload((prevState) => ({
                  ...prevState,
                  end_date: e.target.value,
                }))
              }
              value={addReconciliationPayload?.end_date}
              id="endDate"
              type="date"
              placeholder="Enter a End Date"
              className={
                reconciliationDoneToday
                  ? "hidden"
                  : "outline-none border-sky-300 border rounded-lg p-[0.5rem] flex-1"
              }
            />
          </div>
          <div className="mt-2 flex justify-start items-center text-[0.8rem] text-gray-700 space-x-3">
            <div className="flex justify-start items-center space-x-1">
              <p>Cash In :</p>
              <p>MYR {agentCashIn?.cash_in}</p>
            </div>
            <div className="flex justify-start items-center space-x-1">
              <p>Cash Out :</p>
              <p>{agentCashOut?.cash_out}</p>
            </div>
            <div className="flex justify-start items-center space-x-1">
              <p>Claims :</p>
              <p>MYR {agentClaims?.claims}</p>
            </div>
          </div>
          <div
            className={
              reconciliationDoneToday
                ? "hidden"
                : "mt-2 flex justify-start items-center"
            }>
            <label className="w-[20rem] text-gray-600">Cash +/-</label>
            <input
              onChange={(e) =>
                setAddReconciliationPayload((prevState) => ({
                  ...prevState,
                  cash_difference: e.target.value,
                  employee_ref:
                    userDataFromStorage.user_role === "agent" ||
                    userDataFromStorage.user_role === "senior_agent"
                      ? userDataFromStorage.employee_number
                      : filterData[0]?.agent_id,
                }))
              }
              value={addReconciliationPayload?.cash_difference}
              type="number"
              placeholder="Enter Cash Out Detail"
              className="outline-none border-sky-300 border rounded-lg p-[0.5rem] flex-1"
            />
          </div>

          <div className="mt-2 flex justify-start items-center space-x-3">
            <button
              onClick={() => addReconciliationHandler()}
              style={{ backgroundColor: coloredTheme }}
              className={
                reconciliationDoneToday
                  ? "hidden"
                  : "flex justify-center items-center mt-6 rounded space-x-2 transition duration-[0.6s] px-[1rem] py-[0.5rem] text-white"
              }>
              <FiSearch />
              <p>Save</p>
            </button>
            {/* <button
              style={{ backgroundColor: coloredTheme }}
              onClick={() => setShowAddReconciliation(false)}
              className="flex justify-center items-center mt-6 rounded space-x-2 transition duration-[0.6s] px-[1rem] py-[0.5rem] text-white">
              <FiSearch />
              <p>Cancel</p>
            </button> */}
          </div>
        </>
      ) : (
        ""
      )}

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default CashPlus;
